import { MachineConfig } from 'xstate'
import { ChatMachineSchema, ChatMachineEvent, ChatMachineContext } from './interfaces-livechat';
import * as moment from 'moment';
import { Logger } from './chatbot-logger.service'
import { MessageBus } from './service-bus.service'


export const chatStateMachineConfig: MachineConfig<ChatMachineContext, ChatMachineSchema, ChatMachineEvent> = {
  id: 'form',
  initial: 'botLoaded',
  context: {
    isError: false,
    waitForOpCounter: 0,
    states: [],
    events: []
  },
  states: {
    botLoaded: {
      entry: [],
      on: {
        BOT_ONLINE: {
          target: 'botAvailable'

        },
        OP_DISABLED: {
          target: 'botActiveOpDisabled'

        },
        BOT_OFFLINE: {
          target: 'botError'

        },
        TESTING: {
          target: 'opFeedback'

        }

      }
    },

    botActiveOpDisabled:{

    },
    botAvailable: {
      //predchodny stav, rozcestnik na bot online pri on/off shift LV
      entry: ['saveBotAvailabilityStatus', 'publishMachineEventToBus'],
      on: {
        '': [
          { target: 'opAvailCheck', cond: 'areChatWorkingHoursOn' },
          { target: 'botActiveNoOp', cond: 'areChatWorkingHoursOff' }
        ]
      }

    },
    botError: {
      //Prechodny stav -> neni nutne resit v UI aplikace
      entry: ['saveBotAvailabilityStatus', 'publishMachineEventToBus'],
      on: {
        '': [
          { target: 'opAvailCheck', cond: 'areChatWorkingHoursOn' },
          { target: 'botErrorOpOffshift', cond: 'areChatWorkingHoursOff' }
        ]
      }
    },

    opAvailCheck: {
      /* 
      Prechodny stav -> neni nutne resit v UI aplikace 
      
      */
      entry: ['checkChatAvailabilityStatus', 'publishMachineEventToBus'],
      on: {
        OP_ONLINE: {
          target: 'botActiveAndWaitingToStartOfferOp'

        },
        OP_OFFLINE: {
          target: 'botActiveOpError'

        },
        OP_BUSY: {
          target: 'botActiveOpBusy'

        },
        OP_ONLINE_CHAT_ERR: {
          target: 'opAvailableBotError'

        },
        OP_OFFLINE_CHAT_ERR: {
          target: 'opErrorBotError'

        },
        OP_BUSY_CHAT_ERR: {
          target: 'opBusyBotError'

        },
        BOT_OFFLINE: {
          target: 'botError'

        }
      }
    },

    botActiveNoOp: {
      /* HLAVNI STAV CHATBOTA (OK, OFF WORK HOURS) probihaji otazky s OFFSHIFT HOURS, OP offline ZADNE TLACITKO PRO LV
        NEMA SE KAM MENIT
      */
      entry: ['publishMachineEventToBus'],
      on: {
        BOT_OFFLINE: {
          target: 'botError'

        }
      }

    },
    botActiveOpError: {
      /* HLAVNI STAV CHATBOTA (OK, OFF WORK HOURS) probihaji otazky s ON-SHIFT HOURS, OP offline ZADNE TLACITKO PRO LV
        NEMA SE KAM MENIT
      */
      entry: ['publishMachineEventToBus'],
      on: {
        OP_ONLINE: {
          target: 'botActiveAndWaitingToStartOfferOp'

        }
      }

    },
    botActiveOpBusy: {
      /* HLAVNI STAV CHATBOTA (OK, OFF WORK HOURS) probihaji otazky s ON-SHIFT HOURS, OP busy ZADNE TLACITKO PRO LV
        NEMA SE KAM MENIT
      */
      entry: ['publishMachineEventToBus'],
      on: {
        OP_ONLINE: {
          target: 'botActiveAndWaitingToStartOfferOp'

        }
      }

    },

    botActiveAndWaitingToStartOfferOp: {
      /* HLAVNI STAV CHATBOTA (OK, ON  WORK HOURS) probihaji otazky, ON hours, OP online, je mozne od 2,3 otazky zobrazit tlacitko
        MENI SE DO STAVU S TLACITKEM
      */
      entry: ['publishMachineEventToBus'],
      on: {
        BOT_ONLINE_OFFER_OP: {
          target: 'botActiveOfferingOp'

        },
        OP_BUSY: {
          target: 'botActiveOpBusy'

        },
        OP_OFFLINE: {
          target: 'botActiveOpError'

        }
      }
    },

    //Tato sekce je pro BOT available
    botActiveOfferingOp: {/* ZOBRAZENO tlacitko na op LV od druhe otazky s jednou odpovedi, pro 3+ jiz pokazde**/
      entry: ['publishMachineEventToBus'],
      on: {
        OP_WAITING_FOR_GDPR_CONSENT: {
          target: 'opWaitingForGdprConsent'

        },
        OP_UNEXPECTED_ERR: {
          target: 'botError'

        }
      }
    },
    botErrorOpOffshift: {
      //PRI chybe bot a off-hours chat
      entry: ['sendMessageBotErrChatOff', 'publishMachineEventToBus'],
      on: {
        BOT_OFFLINE: {
          target: 'botError'

        },
        BOT_ONLINE: {
          target: 'botAvailable'

        }
       
      }
    },


    //Tato sekce je pro BOT offline/err
    opAvailableBotError: {/* pri ONLINE pred prepnutim na LV, je zobrazeno tlacitko pro start LV*/
      entry: ['sendMessageBotErrChatOn', 'publishMachineEventToBus'],
      on: {
        OP_WAITING_FOR_GDPR_CONSENT: {
          target: 'opWaitingForGdprConsent'

        }
      }

    },
    opErrorBotError: {
      /* BOT a LV je nedostupny v pracovni dobe OP
      ALE MUSIM NEJAK ZKUSIT RECOVERY?
      */
      entry: ['sendMessageBotErrChatErr', 'publishMachineEventToBus'],
      on: {
        BOT_ONLINE_OFFER_OP: {
          target: 'botActiveOfferingOp'

        }
      }



    },
    opBusyBotError: {/* pri BUSY a bot error -> nic nezobrazuji ALE MUSIM NEJAK ZKUSIT RECOVERY?*/
      entry: ['sendMessageBotErrChatBusy', 'publishMachineEventToBus'],
      on: {
        BOT_ONLINE_OFFER_OP: {
          target: 'botActiveOfferingOp'

        }
      }

    },
    opWaitingForGdprConsent: {/* new chat req. a ceka na potvrzeni GDPR souhlasu: ANO/NE tlacitka, text, cervena dlouha zprava*/
      entry: ['sendMessageStartOfWaitingForGdprConsent', 'publishMachineEventToBus'],
      exit: [],
      after: {
        30000: 'waitingForGdprConsentWasEndedByUser'
      },
      on: {
        OP_WAITING_FOR_OP_1: {
          target: 'opWaitingForOp1'
        },
        
        OP_ENDED_BY_USER: {
          target: 'waitingForGdprConsentWasEndedByUser'
        },
        OP_UNEXPECTED_ERR: {
          target: 'botError'

        }
      }
    },
    opWaitingForOp1: {/* new chat req. a ceka na op. N x 180s  podle mackani ANO/NE tlacitka*/
      entry: ['sendMessageDontBrowseInThisWindow','sendMessageStartOfWaitingForOp1','sendWaitingMessageForOp1_2', 'publishMachineEventToBus'],
      exit: [],
      after: {
        180000: 'opWaitingForUser'
      },
      on: {
        OP_WAITING_FOR_USER: {
          target: 'opWaitingForUser'
        },
        OP_DID_START: {
          target: 'opActive'
        },
        OP_ENDED_BY_USER: {
          target: 'waitingForOpWasEndedByUser'
        },
        OP_UNEXPECTED_ERR: {
          target: 'opDidNotStart'

        }
      }
    },
    opWaitingForUser: {/* new chat req. a ceka na zmacknuti tlacitka 45 sec. Pokud ne tak */
      entry: ['sendMessageEndOfWaitingForOp1', 'publishMachineEventToBus','playNotificationOnWaitForUser'],

      after: {
        45000: 'opDidNotStart'
      },
      on: {
        OP_CONTINUE_TO_WAIT: {
          target: 'opWaitingForOp2'
        },
        OP_ENDED_BY_USER: {
          target: 'waitingForOpWasEndedByUser'
        },
        OP_DID_START: {
          /*operator mezitim prijal */
          target: 'opActive'
        },
        OP_UNEXPECTED_ERR: {
          target: 'opDidNotStart'

        }
      }

    },
    opWaitingForOp2: {/* Puvodne cekani na op. druhych 180, nyni pouze pro poslani message a navrat do "nekonecne" smycky cekani */
      entry: ['sendMessageStartOfWaitingForOp2', 'sendWaitingMessageForOp1_2','publishMachineEventToBus'],

      after: {
        180000: 'opWaitingForUser'
      },
      on: {
        OP_WAITING_FOR_USER: {
          target: 'opWaitingForUser'
        },
        OP_DID_START: {
          target: 'opActive'
        },
        OP_ENDED_BY_USER: {
          target: 'waitingForOpWasEndedByUser'
        },
        OP_UNEXPECTED_ERR: {
          target: 'opDidNotStart'

        }
      }
    },
    opDidNotStart: {/* new chat req. se nepodarilo zacit (timeout, zruseni uzivatelem) 
      --> pravdepodobne jit primo do opEnded?
      */
      entry: ['sendMessageEndOfWaitingForOp2', 'publishMachineEventToBus'],
      after: {
        1000: 'opEnded'
      },

    },

    opActive: {/* probiha komunikace s op LV*/
      entry: ['publishMachineEventToBus','playNotificationOnOpStart'],
      on: {
        OP_FEEDBACK: {
          target: 'opFeedback'
        },
        OP_UNEXPECTED_ERR: {
          target: 'opDidNotStart'

        }
      }
    },
    opFeedback: {/* probiha hodnoceni LV*/
      entry: ['sendMsgLivechatConnClosed','publishMachineEventToBus'],
      exit: [],
      after: {
        10000: 'opEnded'
      },
      on: {
        OP_FEEDBACK_DONE: {
          target: 'opEnded'
        },
        OP_UNEXPECTED_ERR: {
          target: 'botError'

        }
      }
    },
    waitingForOpWasEndedByUser: {
      /* zruseni uzivatelm(45 sec tlacitko) pouze PRO cekani na OP, event: OP_ENDED_BY_USER, 
      NEPLATI v prubehu chatu je  event: OP_FEEDBACK 
      */
      entry: ['sendMessageCancelWaitingForOpByUser', 'publishMachineEventToBus'],
      after: {
        2000: 'opEnded'
      }
    },

    waitingForGdprConsentWasEndedByUser: {
      /* zruseni uzivatelm(45 sec tlacitko) pouze PRO cekani na OP, event: OP_ENDED_BY_USER, 
      NEPLATI v prubehu chatu je  event: OP_FEEDBACK 
      */
      entry: ['sendMessageCancelWaitingForGdprConsentByUser', 'publishMachineEventToBus'],
      after: {
        2000: 'opEnded'
      }
    },
  
    opEnded: {/* skoncena session s op LV po feedback kroku, POZOR PARENT komoponenta zjistuje dostupnost BOT a posila event/messages pri exit*/
      entry: ['makeEndChatApiCall'],
      exit: [''],
      on: {
        BOT_ONLINE: {
          target: 'botAvailable'

        },
        BOT_OFFLINE: {
          target: 'botError'

        },
        TESTING: {
          target: 'botLoaded'

        }

      }
    }


  }
}


